// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeacherCard_container__h1cqe {
  row-gap: 8px;
  max-width: 200px;
  box-sizing: border-box;
}
.TeacherCard_innerContainer__r11IV {
  border: 1px solid #e2e2e2;
}
.TeacherCard_innerContainer__r11IV,
.TeacherCard_mentorContainer__CDAQk {
  border-radius: 8px;
  display: flex;
  padding: 16px;
  row-gap: 8px;
}
.TeacherCard_mentorContainer__CDAQk {
  border: 1px solid #cb9c2d;
}
.TeacherCard_photoWrapper__rCd5e {
  display: flex;
  align-items: baseline;
  justify-content: center;
  position: relative;
}
.TeacherCard_container__h1cqe,
.TeacherCard_innerContainer__r11IV,
.TeacherCard_mentorContainer__CDAQk,
.TeacherCard_photoWrapper__rCd5e {
  flex-direction: column;
}
.TeacherCard_container__h1cqe,
.TeacherCard_pill__oFo7L {
  display: flex;
  align-items: center;
}
.TeacherCard_pill__oFo7L {
  position: absolute;
  top: 0px;
  justify-content: center;
  background-color: #cb9c2d;
  height: 25px;
  border-radius: 4px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #ffffff;
  width: 81px;
}
.TeacherCard_photo__XaeS1 {
  border: 0.5px solid #e2e2e2;
  border-radius: 4px;
  height: 112px;
  object-fit: cover;
  overflow: hidden;
  width: 171px;
}
.TeacherCard_title__hqb7Z {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.TeacherCard_infoContainer__w2R-2 {
  display: flex;
  flex-direction: column;
  row-gap: 4.5px;
}
.TeacherCard_infoItemRow__R6BIw {
  column-gap: 4px;
  cursor: pointer;
  display: flex;
  text-decoration: none;
  width: fit-content;
}
.TeacherCard_infoItemText__ImFtk {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  margin: 0px;
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}
.TeacherCard_infoItemIcon__iyTRJ {
  stroke: #4d4d4d;
}
.TeacherCard_horizontalLine__EcskB {
  background-color: #828d9a;
  height: 1px;
  width: 40px;
}
.TeacherCard_bottomText__sw9cR {
  color: #828d9a;
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
}
.TeacherCard_overlay__s9ipT {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.TeacherCard_modalContainer__Z0ePE {
  height: 450px;
  width: 700px;
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  box-sizing: border-box;
}

.TeacherCard_modalText__br4mf {
  height: 60%;
  width: 100%;
  color: #4d4d4d;
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  overflow: auto;
}

.TeacherCard_modalTitle__qflNC {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.001em;
  margin-bottom: 20px;
}

.TeacherCard_closeButton__MbIeh {
  width: 30%;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  height: 42px;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
  background: #cb9c2d;
  color: #fff;
}
.TeacherCard_closeButton__MbIeh:hover {
  background-color: #7b7b7b;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/singleGroup/components/teacherCard/TeacherCard.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;;;EAIE,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  row-gap: 8px;\n  max-width: 200px;\n  box-sizing: border-box;\n}\n.innerContainer {\n  border: 1px solid #e2e2e2;\n}\n.innerContainer,\n.mentorContainer {\n  border-radius: 8px;\n  display: flex;\n  padding: 16px;\n  row-gap: 8px;\n}\n.mentorContainer {\n  border: 1px solid #cb9c2d;\n}\n.photoWrapper {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  position: relative;\n}\n.container,\n.innerContainer,\n.mentorContainer,\n.photoWrapper {\n  flex-direction: column;\n}\n.container,\n.pill {\n  display: flex;\n  align-items: center;\n}\n.pill {\n  position: absolute;\n  top: 0px;\n  justify-content: center;\n  background-color: #cb9c2d;\n  height: 25px;\n  border-radius: 4px;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #ffffff;\n  width: 81px;\n}\n.photo {\n  border: 0.5px solid #e2e2e2;\n  border-radius: 4px;\n  height: 112px;\n  object-fit: cover;\n  overflow: hidden;\n  width: 171px;\n}\n.title {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n}\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 4.5px;\n}\n.infoItemRow {\n  column-gap: 4px;\n  cursor: pointer;\n  display: flex;\n  text-decoration: none;\n  width: fit-content;\n}\n.infoItemText {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  margin: 0px;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 150px;\n}\n.infoItemIcon {\n  stroke: #4d4d4d;\n}\n.horizontalLine {\n  background-color: #828d9a;\n  height: 1px;\n  width: 40px;\n}\n.bottomText {\n  color: #828d9a;\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n}\n.overlay {\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 10000000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modalContainer {\n  height: 450px;\n  width: 700px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 30px;\n  box-sizing: border-box;\n}\n\n.modalText {\n  height: 60%;\n  width: 100%;\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  overflow: auto;\n}\n\n.modalTitle {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 26px;\n  letter-spacing: -0.001em;\n  margin-bottom: 20px;\n}\n\n.closeButton {\n  width: 30%;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 42px;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n  background: #cb9c2d;\n  color: #fff;\n}\n.closeButton:hover {\n  background-color: #7b7b7b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TeacherCard_container__h1cqe`,
	"innerContainer": `TeacherCard_innerContainer__r11IV`,
	"mentorContainer": `TeacherCard_mentorContainer__CDAQk`,
	"photoWrapper": `TeacherCard_photoWrapper__rCd5e`,
	"pill": `TeacherCard_pill__oFo7L`,
	"photo": `TeacherCard_photo__XaeS1`,
	"title": `TeacherCard_title__hqb7Z`,
	"infoContainer": `TeacherCard_infoContainer__w2R-2`,
	"infoItemRow": `TeacherCard_infoItemRow__R6BIw`,
	"infoItemText": `TeacherCard_infoItemText__ImFtk`,
	"infoItemIcon": `TeacherCard_infoItemIcon__iyTRJ`,
	"horizontalLine": `TeacherCard_horizontalLine__EcskB`,
	"bottomText": `TeacherCard_bottomText__sw9cR`,
	"overlay": `TeacherCard_overlay__s9ipT`,
	"modalContainer": `TeacherCard_modalContainer__Z0ePE`,
	"modalText": `TeacherCard_modalText__br4mf`,
	"modalTitle": `TeacherCard_modalTitle__qflNC`,
	"closeButton": `TeacherCard_closeButton__MbIeh`
};
export default ___CSS_LOADER_EXPORT___;
